import * as React from 'react';
import PBASForm from './PBAS';

const BehaviourForm = ({ formData, document, viewing = false }: IOwnProps): React.JSX.Element | null =>
  document?._type === 'pbaS' ? <PBASForm formData={formData} viewing={viewing} /> : null;

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'pbaS'>>;
  document?: IDocumentWithTypeV2<'pbaS'>;
  viewing?: boolean;
}

export default BehaviourForm;
